import { render } from "./icon-list-alt.vue?vue&type=template&id=2ef72b92"
import script from "./icon-list-alt.vue?vue&type=script&lang=js"
export * from "./icon-list-alt.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__